import ReviewsService from '../services/reviews-service';
import GeoMappingsService from '../services/geomappings-service';
import { mixin as clickaway } from 'vue-clickaway';

Vue.component('reviews-date-picker', {
  props: ['fromDate', 'toDate', 'dateRange', 'compare'],
  template: `
        <div ref="reviews_date_picker" class="dropdown-select date-picker">{{ date_text }}</div>
    `,

  computed: {
    date_text() {
      return this.getDatePickerLabel(this.fromDate, this.toDate, this.dateRange);
    },
  },

  watch: {
    fromDate: function (newVal, oldVal) {
      let element = this.$refs.reviews_date_picker;
      $(element).daterangepicker(
        {
          ranges: this.getDefaultDateRanges(),
          autoApply: true,
          startDate: moment(this.fromDate),
          endDate: moment(this.toDate),
          alwaysShowCalendars: true,
          opens: 'center',
          showDropdowns: true,
          minDate: moment('2000-01-01'),
          maxDate: moment().endOf('year'),
        },
        this.updateDates,
      );
    },
  },

  mounted() {
    moment.locale();

    let element = this.$refs.reviews_date_picker;

    this.$eventHub.$on('update-home-dates-for-reviews', (fromDate, toDate, dateRangeAsString) => {
      this.$parent.updateDates(fromDate, toDate, dateRangeAsString);
    });

    // Handle the case when 'from', 'to' dates are provided in the URL for showing Reviews in these days
    let url = new URL(window.location.href);
    let fromDateUrl = url.searchParams.get('from');
    let toDateUrl = url.searchParams.get('to');
    let sourcesUrl = url.searchParams.getAll('source');

    let fromDate = fromDateUrl ? fromDateUrl : this.fromDate;
    let toDate = toDateUrl ? toDateUrl : this.toDate;

    $(element).daterangepicker(
      {
        ranges: this.getDefaultDateRanges(),
        autoApply: true,
        startDate: moment(fromDate),
        endDate: moment(toDate),
        alwaysShowCalendars: true,
        opens: 'center',
        showDropdowns: true,
        minDate: moment('2000-01-01'),
        maxDate: moment().endOf('year'),
      },
      this.updateDates,
    );

    if (fromDateUrl && toDateUrl) {
      this.$eventHub.$emit('update-home-dates-for-reviews', fromDateUrl, toDateUrl, '');
    }
    Vue.nextTick(() => {
      if (sourcesUrl.length > 0) {
        this.$eventHub.$emit('applyFilters', { source: sourcesUrl });
      }
    });
  },

  methods: {
    updateDates(fromDate, toDate, type) {
      if (this.compare) {
        this.$parent.updateComparisonDates(fromDate.format('YYYY-MM-DD'), toDate.format('YYYY-MM-DD'), type);
        this.$eventHub.$emit('editModeChanged', false);
      } else {
        this.$parent.updateDates(fromDate.format('YYYY-MM-DD'), toDate.format('YYYY-MM-DD'), type);
        this.$eventHub.$emit('editModeChanged', false);
      }
    },
  },
});
Vue.component('review-actions', {
  props: ['reviews'],
  template: /*html*/ `
  <div class="dropdown">
    <div class="dropdown-select" :class="{ active: editMode }" data-toggle="dropdown">
      <span :class="{ active: editMode }">{{ editMode ? __('Select Action') : __('Actions') }}</span>
    </div>
    <div class="dropdown-menu">
    <div v-if="$global.isMobile && editMode">
        <a class="dropdown-item" href="#" @click="markSelectedReviewsAsResponded">Mark Selected Reviews As Responded</a>
        <a class="dropdown-item" href="#" @click="markAllReviewsAsResponded">Mark All Reviews As Responded</a>
        </div>
      <a class="dropdown-item" href="#" @click="enterEditMode">
        {{ editMode ? __('Stop Editting') : __('Edit') }}
      </a>
    </div>
    <div class="actionsBox" v-if="!$global.isMobile && editMode">
      <div class="titleBar">
        Actions
      </div>
      <div class="buttonsWrapper">
        <button class="btn btn-primary" @click="markSelectedReviewsAsResponded">
          Mark Responded
        </button>
        <button class="btn btn-primary" @click="markAllReviewsAsResponded">
          Mark All As Responded
        </button>
      </div>
      <div class="buttonBar">
        <button class="btn btn-exit"  href="#" @click="enterEditMode">
          Exit
        </button>
      </div>
    </div>
  </div>
  `,

  data() {
    return {
      editMode: false,
      selectedReviews: [],
    };
  },
  mounted() {
    this.$eventHub.$on('editModeChanged', (newEditMode) => {
      this.editMode = newEditMode;
    });
    this.$eventHub.$on('review-selected', (reviewId, selected) => {
      if (selected) {
        this.selectedReviews.push(reviewId);
      } else {
        const index = this.selectedReviews.indexOf(reviewId);
        if (index > -1) {
          this.selectedReviews.splice(index, 1);
        }
      }
    });
  },

  methods: {
    enterEditMode() {
      this.editMode = !this.editMode;

      for (let review of this.reviews) {
        if (review.response_status === 'has_response') {
          return;
        }
        review.editMode = this.editMode;
      }

      this.$eventHub.$emit('editModeChanged', this.editMode);
    },
    markAllReviewsAsResponded() {
      swal(
        {
          title: 'Mark all Reviews as Responded?',
          text: 'All reviews will be marked as responded and cannot be reverted back.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, mark them all!',
          allowOutsideClick: true,
          allowEscapeKey: true,
        },
        () => {
          const reviewIds = this.reviews.map((review) => review.id);

          axios
            .post('/api/reviews/' + Spark.state.currentTeam.id + '/markSelectedResponded', { reviews: reviewIds })
            .then((response) => {
              $('body').removeClass('stop-scrolling');
              this.$emit('reviews-updated');
              this.$eventHub.$emit('editModeChanged', false);
            })
            .catch((error) => {
              swal('Oops!', 'Something went wrong with your response. Our team has been notified', 'error');
              $('body').removeClass('stop-scrolling');
            });
        },
      );
    },
    markSelectedReviewsAsResponded() {
      const reviewIds = this.selectedReviews;
      if (reviewIds.length === 0) {
        swal({
          title: 'No Reviews Selected!',
          text: 'Please select at least one review',
          icon: 'warning',
          buttons: true,
          dangerMode: true,
        });
        return;
      }

      swal(
        {
          title: 'Are you sure?',
          text: 'All selected reviews will be marked as responded and cannot be reverted back.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, mark them!',
          allowOutsideClick: true,
          allowEscapeKey: true,
        },
        () => {
          axios
            .post('/api/reviews/' + Spark.state.currentTeam.id + '/markSelectedResponded', { reviews: reviewIds })
            .then((response) => {
              $('body').removeClass('stop-scrolling');
              this.$emit('reviews-updated');
              this.$eventHub.$emit('editModeChanged', false);
              this.editMode = false;
              this.selectedReviews = [];
            })
            .catch((error) => {
              swal('Oops!', 'Something went wrong with your response. Our team has been notified', 'error');
              $('body').removeClass('stop-scrolling');
            });
        },
      );
    },
  },
});
Vue.component('response-filter', {
  props: ['responseFilter', 'hasReviewResponseApproval'],
  template: /*html*/`
        <div class="dropdown square">

            <div class="dropdown-select" data-toggle="dropdown" >
                <span :class="{active: responseFilter != ''}">{{ filterLabel }}</span>
            </div>

            <div class="dropdown-menu">
                <a class="dropdown-item"
                    :class="{active: responseFilter == ''}"
                    href="#" @click="enableFilter($event, '')">{{__('All Reviews')}}</a>
                <a class="dropdown-item"
                    :class="{active: responseFilter == 'noResponse'}"
                    href="#" @click="enableFilter($event, 'noResponse')">{{__('Not Responded')}}</a>
                <a class="dropdown-item"
                    :class="{active: responseFilter == 'hasResponse'}"
                    href="#" @click="enableFilter($event, 'hasResponse')">{{__('Responded')}}</a>
                <a class="dropdown-item"
                    :class="{active: responseFilter == 'importantResponse'}"
                    href="#" @click="enableFilter($event, 'importantResponse')">{{__('Show Only Important')}}</a>
                <a class="dropdown-item"
                    :class="{active: responseFilter == 'noComments'}"
                    href="#" @click="enableFilter($event, 'noComments')">{{__('No Comments')}}</a>   
                <a class="dropdown-item"
                    :class="{active: responseFilter == 'withComments'}"
                    href="#" @click="enableFilter($event, 'withComments')">{{__('With Comments')}}</a>
                <a class="dropdown-item"
                    :class="{active: responseFilter == 'withNotes'}"
                    href="#" @click="enableFilter($event, 'withNotes')">{{__('With Notes')}}</a>
                <a class="dropdown-item"
                    :class="{active: responseFilter == 'withoutNotes'}"
                    href="#" @click="enableFilter($event, 'withoutNotes')">{{__('Without Notes')}}</a>
                <a v-if="hasReviewResponseApproval" class="dropdown-item"
                    :class="{active: responseFilter == 'noSuggestions'}"
                    href="#" @click="enableFilter($event, 'noSuggestions')">{{__('No Suggestions')}}</a>
                <a v-if="hasReviewResponseApproval" class="dropdown-item"
                    :class="{active: responseFilter == 'withSuggestions'}"
                    href="#" @click="enableFilter($event, 'withSuggestions')">{{__('With Suggestions')}}</a>
            </div>
        </div>
    `,

  mounted() {},

  data() {
    return {};
  },

  computed: {
    filterLabel() {
      switch (this.responseFilter) {
        case '':
          return __('All Reviews');
        case 'noResponse':
          return __('Not Responded');
        case 'importantResponse':
          return __('Important Only');
        case 'hasResponse':
          return __('Responded');
        case 'withComments':
          return __('With Comments');
        case 'noComments':
          return __('No Comments');
        case 'withNotes':
          return __('With Notes');
        case 'withoutNotes':
          return __('Without Notes');
        case 'withSuggestions':
          return __('With Suggestions');
        case 'noSuggestions':
          return __('No Suggestions');
      }
    },
  },

  methods: {
    enableFilter(event, filter) {
      event.preventDefault();
      this.$eventHub.$emit('applyFilters', { responseFilter: filter });
    },
  },
});

Vue.component('importance-filter', {
  props: ['importance'],
  template: `
        <div class="dropdown square">

            <div class="dropdown-select" data-toggle="dropdown">
                <span v-if="importance == '' || importance == '-'">{{ __("All Importances") }}</span>
                <span v-else class="active">{{ importanceValues[importance] }}</span>
            </div>

            <div class="dropdown-menu">
                <a v-for="(label, anImportance) in importanceValues"
                   class="dropdown-item"
                   :class="{active: importance == anImportance}"
                   href="#" @click="filterImportance($event, anImportance)">{{ label }}</a>
            </div>
        </div>
    `,
  mounted() {},

  data() {
    return {
      importanceValues: {
        '': __('All Importances'),
        high: __('High Importance'),
        medium: __('Medium Importance'),
        low: __('Low Importance'),
      },
    };
  },
  methods: {
    filterImportance(event, importance) {
      event.preventDefault();
      this.$eventHub.$emit('applyFilters', { importance: importance });

      this.$eventHub.$emit('editModeChanged', false);
    },
  },
});

Vue.component('per-page-filter', {
  data() {
    return {
      reviewCount: 6,
      availableOptions: [6, 10, 20, 50, 100],
    };
  },
  template: `
        <div class="dropdown">
            <div class="dropdown-select" data-toggle="dropdown">
                <span>
                    {{reviewCount}} {{ __('Reviews / Page') }}
                </span>
            </div>

            <div class="dropdown-menu">
                <a v-for="count in availableOptions"
                class="dropdown-item"
                :class="{active: reviewCount == count}"
                href="#" @click="changeCount(count)">{{ count }} {{ __('Reviews / Page') }}</a>
            </div>
        </div>
    `,
  mounted() {},
  methods: {
    changeCount(newCount) {
      this.reviewCount = newCount;
      this.$eventHub.$emit('applyFilters', { perPage: newCount });
      this.$eventHub.$emit('editModeChanged', false);
    },
  },
});

Vue.component('language-filter', {
  props: ['language'],
  template: `
        <div class="dropdown">

            <div class="dropdown-select" data-toggle="dropdown">
                <span v-if="language == '' || language == '-'">
                    <i class="fas fa-language"></i>
                    {{ __('All Languages') }}
                </span>
                <span v-else class="active">{{ availableLanguages[language] }}</span>
            </div>

            <div class="dropdown-menu">
                <a v-for="(label, lang) in availableLanguages"
                   class="dropdown-item"
                   :class="{active: language == lang}"
                   href="#" @click="filterLanguage($event, lang)">{{ label }}</a>
            </div>
        </div>
    `,
  mounted() {},

  data() {
    return {
      availableLanguages: {
        '': __('All Languages'),
        en: __('English'),
        fr: __('French'),
        de: __('German'),
        nl: __('Dutch'),
        el: __('Greek'),
        es: __('Spanish'),
        it: __('Italian'),
        ru: __('Russian'),
        pl: __('Polish'),
        cz: __('Czech'),
      },
    };
  },
  methods: {
    filterLanguage(event, language) {
      event.preventDefault();
      this.$eventHub.$emit('applyFilters', { language: language });
      this.$eventHub.$emit('editModeChanged', false);
    },
  },
});

Vue.component('reviews-type-filter', {
  props: ['type'],
  template: `
        <div class="positive-negative-filter">
            <div class="d-inline-block selectors">
                <a v-for="(label, option) in availableTypes" href="#" @click="filterType($event, option)" :class="optionClasses(option)">
                    <strong class="light-text">{{ __(label) }}</strong>
                </a>
            </div>
        </div>
    `,
  mounted() {},

  data() {
    return {
      availableTypes: {
        '': __('All Reviews'),
        positive: __('Positive'),
        negative: __('Negative'),
      },
    };
  },
  methods: {
    filterType(event, type) {
      event.preventDefault();
      this.$eventHub.$emit('applyFilters', { reviews: type });
    },
    optionClasses(option) {
      let optionClass = 'text-uppercase sentiment-' + option + '-filter';

      if (option == '') {
        optionClass += ' ml-0';
      }

      if (this.type == option) {
        optionClass += ' active';
      }

      return optionClass;
    },
  },
});

Vue.component('source-filter', {
  props: ['source', 'availableChannels'],
  template: `
        <div class="dropdown square">

            <div class="dropdown-select" data-toggle="dropdown">
                <span v-if="source != '' && source != 'none' && source.length > 0" class="active d-inline-block text-truncate" style="max-width: 9.4em">{{ formattedSources }}</span>
                <span v-else>{{ __('All Review Sites') }}</span>
            </div>

            <div class="dropdown-menu dropdown-scroll">
                <a class="dropdown-item" :class="{active: source == 'none'}"
                    href="#" @click="resetFilters">{{ sources['none'] }}
                </a>

                <a v-for="aSource in channels" v-if="aSource != 'none'"
                    class="dropdown-item" href="#" @click="toggleSource($event,aSource)">
                    <div class="row">
                        <div class="col-2"><input class="mr-2" type="checkbox" :value=aSource v-model="enabledSources" ></div>
                        <div class="col-8 pl-2 pt-1">{{ sources[aSource] }}</div>
                    </div>
                </a>
            </div>
        </div>
    `,
  data() {
    return {
      sources: {
        none: 'All Review Sites',
        facebook_pages: 'Facebook',
        trip_advisor: 'TripAdvisor',
        booking_com: 'Booking.com',
        hotels_com: 'Hotels.com',
        google: 'Google',
        zoover: 'Zoover',
        agoda: 'Agoda',
        cheaptickets: 'CheapTickets',
        ctrip: 'CTrip',
        ebookers: 'Ebookers.ie',
        expedia: 'Expedia',
        goibibo: 'Goibibo',
        holiday_check: 'HolidayCheck',
        hotels_de: 'Hotels.de',
        hrs: 'HRS',
        orbitz: 'Orbitz',
        priceline: 'Priceline',
        travelocity: 'Travelocity',
        venere: 'Venere',
        wotif: 'Wotif',
        lastminute: 'lastminute.com',
        holiday_iq: 'HolidayIQ',
        hotel_specials: 'Hotelspecials.nl',
        weekendje_weg: 'Weekendjeweg.nl',
        thefork: 'thefork',
        hotels_nl: 'Hotels.nl',
        hotelkamerveiling: 'HotelKamerVeiling.nl',
        airbnb: 'Airbnb',
        hoteliers_com: 'Hoteliers.com',
        hotel_feedback: 'HotelFeedback',
        exclusivi: 'Exclusivi',
        top_hotels_ru: 'TopHotels.ru',
        weg_de: 'Weg.de',
        urlaub_de: 'Ab-in-den-urlaub',
        tui_com: 'Tui.com',
        check24_de: 'Check24',
        atrapalo_com: 'Atrapalo',
        yelp: 'Yelp',
        voyage_prive: 'Voyage Prive',
        itaka_pl: 'Itaka.pl',
        travel_republic: 'Travel Republic',
        corendon_nl: 'Corendon.nl',
        foursquare: 'FourSquare',
        opentable: 'OpenTable',
        zomato: 'Zomato',
        cruisecritic: 'Cruise Critic',
        directbooking: 'HalalBooking',
        tui_nl: 'Tui.nl',
        otelpuan: 'Otelpuan',
        cedok: 'Cedok',
        iescape: 'i-escape',
        google_play: 'Google Play',
        tiket_com: "Tiket.com",
      },
      enabledSources: [],
    };
  },
  mounted() {
    this.$eventHub.$on('applyFilters', (filters) => {
      this.$eventHub.$emit('editModeChanged', false);
      if (filters.source) {
        this.enabledSources = filters.source;
      }
    });
  },
  computed: {
    channels() {
      let channels = ['none'];
      channels = channels.concat(this.availableChannels);
      return channels;
    },
    formattedSources() {
      return this.enabledSources.map((name) => this.labelizeGeneral(name)).join(',');
    },
  },
  methods: {
    resetFilters(event) {
      event.preventDefault();
      this.enabledSources = [];
      this.$eventHub.$emit('applyFilters', { source: this.enabledSources });
    },
    toggleSource(event, source) {
      event.stopPropagation();

      const idx = this.enabledSources.findIndex((src) => src == source);

      if (idx === -1) {
        this.enabledSources.push(source);
      } else {
        this.enabledSources = this.enabledSources.filter((src) => src != source);
      }

      this.$eventHub.$emit('applyFilters', { source: this.enabledSources });
    },
  },
});
Vue.component('guestflip-review', {
	mixins: [clickaway],
	props: {
		review: Object,
		keyword: String,
		user: Object,
		reviewIds: Array,
		showSentiment: Boolean,
		reviewIndex: Number,
		hasReviewResponseApproval: Boolean,
		ratingPreference: String,
    loadingSuggestion: Boolean,
    params: Object,
		outOf: {
			type: Number,
			default: 5,
		},
	},
  data() {
    return {
      selected: false,
      editMode: false,
      managerComment: false,
      isResponseSuggestion: false,
      response: '',
      active_popover: false,
      responded_manually: false,
      respond_message: '',
      storingSentiment: false,
      repliesExpanded: false,
      caseFilesExpanded: false,
      channelsWithResponseRedirects: ['trip_advisor'],
      viewTranslation: true,
      viewManagerTranslation: true,
      response_suggestion: '',
      newManagerComments: [],
      average_rating: this.review.average_rating,
      comments: Array.isArray(this.review.comments) ? this.review.comments : [],
      guest: this.review.guest,
      guest_id: this.review.guest_id,
      id: this.review.id,
      sentiment_score: this.review.sentiment_score,
      team_id: this.review.team_id,
      published_date: this.review.published_date,
      source: this.review.source,
      ratings: this.review.ratings,
      respond_url: this.review.respond_url,
      terms: this.review.terms,
      language: this.review.language,
      entities: this.review.entities,
      importance: this.review.importance,
      api_source: this.review.api_source,
      noteText: this.review.note,
      loadingHint: false,
      activeHint: null,
      isRespondAreaActive: false,
      isResponseLoading: false,
      translating: false,
      invalidating: false,
      showShareReviewModal: false,
      deleted: false,
      selectedTerm: {
        id: null,
        title: null,
      },
      isNoteActive: false,
      isLanguageDropdownOpen: false,
      languages: [
          { code: 'en', name: 'English' },
          { code: 'fr', name: 'French' },
          { code: 'de', name: 'German' },
          { code: 'nl', name: 'Dutch' },
          { code: 'el', name: 'Greek' },
          { code: 'es', name: 'Spanish' },
          { code: 'it', name: 'Italian' },
          { code: 'ru', name: 'Russian' },
          { code: 'pl', name: 'Polish' },
          { code: 'cs', name: 'Czech' },
      ]
    };
  },
  mounted() {
    Vue.nextTick(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    this.$on('hintLoading', this.setLoadingHint);
    this.$on('hintReady', this.applyHint);
    this.$on('expandSection', this.expandSection);
    this.$on('setResponseMessage', this.setResponseMessage);
    this.$on('respond', this.respond);
    this.checkLanguagePreference();
    this.checkAutoReviewsExpandPreference();
    this.$eventHub.$on('editModeChanged', (newEditMode) => {
      this.editMode = newEditMode;
    });
  },

	computed: {
    editReview(){
      return Spark.userPermissions.manage_dashboard;
    },
    sourceAverageRating() {
      if (this.ratingPreference === 'source' && this.outOf !== 5) {
        let currentOutOf = parseFloat(this.outOf);
        let originalRating = parseFloat(this.average_rating);
        let adjustedRating = (originalRating / 5) * currentOutOf;
        return adjustedRating % 1 === 0 ? adjustedRating.toFixed(0) : adjustedRating.toFixed(2);
      }
      return this.average_rating % 1 === 0 ? Number(this.average_rating).toFixed(0) : Number(this.average_rating).toFixed(2);
    },
    preference() {
      return Spark.userPreferences
        ? Spark.userPreferences.filter((preference) => preference.team_id === Spark.state.currentTeam.id)[0]
        : null;
    },
    imageSource() {
      return this.getImageSource(this.source);
    },
    showRecommendationOnly() {
      return this.review.source == 'facebook_pages';
    },

    isHintActive() {
      return !this.respondFromDashboard && this.activeHint != null;
    },
    canHaveHint() {
      return true;
    },
    reviewTitle() {
      return this.viewTranslation && this.review.title_translation 
        ? this.review.title_translation 
        : this.review.title;
    },
    totalCommentCharLength() {
      let commentLength = 0;

      for (comment of this.userComments) {
        let comm = comment['translation'] ? comment['translation'] : comment['comment'];
        commentLength += comm.length;
      }

      return commentLength;
    },

    hasTranslation() {
      const hasTitleTranslation = this.review?.title_translation && this.review.title_translation.trim().length > 0;
      
      const hasCommentTranslation = this.comments?.some(comment => {
        return comment.kind !== 'manager' && 
               comment.translation && 
               comment.translation.length > 1;
      });

      return hasTitleTranslation || hasCommentTranslation;
    },
    

    hasManagerTranslation() {
      return (
        this.comments.filter(function (c) {
          return c.translation != null && c.translation.length > 1 && c.kind == 'manager';
        }).length > 0
      );
    },

    respondByRedirect() {
      return this.respond_url != '' && !this.isRespondFormVisible;
    },

    respondFromDashboard() {
      return this.isRespondFormVisible && this.isRespondAreaActive;
    },

    hasResponseSection() {
      return (
        this.review.response_status != 'has_response' &&
        !this.responded_manually &&
        !this.managementComments.length &&
        !(this.source == 'booking_com' && this.userComments.length == 0) &&
        this.source != 'exclusivi' &&
        this.review.is_source_respondable === true
      );
    },

    hasFileCases() {
      return this.review.case_files && this.review.case_files.length > 0;
    },

    isButtonRespondVisible() {
      return false;
    },

    isRespondFormVisible() {
      return this.review.can_respond_from_dashboard && !this.managementComments.length;
    },

    /**
     * Filters comments and returns only comments made by users
     */
    userComments() {
      return this.comments.filter(function (c) {
        return c.kind != 'manager';
      });
    },

    subRatings() {
      return this.ratings.filter(function (r) {
        return r.topic != 'overall_general';
      });
    },

    /**
     * Filters comments and returns only comments made by management
     */
    managementComments() {
      var filteredComments = this.comments.filter(function (c) {
        return c.kind == 'manager';
      });

      return filteredComments;
    },

    suggestionComment() {
      const suggestion = this.review.comments.find((comment) => comment.kind === 'suggestion');
      return suggestion ? suggestion.comment : '';
    },

    rowClasses() {
      let classes = '';
      classes += this.importance + '-importance';

      if (this.review.vacation_rental) {
        classes += ' has-vacation-rental';
      }

      return classes;
    },
    guestName() {
      if (!this.guest.name) {
        return 'Anonymous';
      }

      return this.guest.name;
    },
    avatarText() {
      if (!this.guest.name) {
        return 'A';
      }

      let nameParts = this.guest.name.split(' ');

      if (nameParts.length == 2) {
        return (nameParts[0].charAt(0) + nameParts[1].charAt(0)).toUpperCase();
      } else {
        return this.guest.name.substr(0, 2).toUpperCase();
      }
    },

    currentTeam() {
      return Spark.state.currentTeam;
    },
    managementAvatarText() {
      let teamName = this.currentTeam.name;

      let nameParts = teamName.split(' ');

      if (nameParts.length == 2) {
        return (nameParts[0].charAt(0) + nameParts[1].charAt(0)).toUpperCase();
      } else {
        return teamName.substr(0, 2).toUpperCase();
      }
    },
    ratingNumber() {
      let num = parseInt(this.average_rating);
      let num2 = parseFloat(this.average_rating);

      if (num != num2) {
        return num2;
      }

      return num;
    },
    hasSuggestionComment() {
      return this.review.comments.some((comment) => comment.kind === 'suggestion');
    },
    hasManagerComment() {
      return this.review.comments.some((comment) => comment.kind === 'manager');
    },
  },

  filters: {
    formatDate: function (date) {
      return moment(date).format('D MMM YYYY');
    },
  },

  methods: {
    caseFileStatusBadge(status) {
      switch (status.toLowerCase()) {
          case 'open':
              return 'badge-success';
          case 'closed':
              return 'badge-danger';
          case 'pending':
              return 'badge-warning';
          default:
              return 'badge-secondary'; 
      }
    },

    caseFilepriorityStyle(priority) {
      const priorities = {
          0: 'low-priority',
          1: 'medium-priority',
          2: 'high-priority',
      };

      return priorities[priority] || '';
  },

    viewCase(caseId) {
      const url = `/cases?caseId=${caseId}#cases-view`;
      window.location.href = url;
    },

    toggleCaseFiles() {
      if (this.repliesExpanded) {
        this.repliesExpanded = false;
      }

      this.caseFilesExpanded = !this.caseFilesExpanded;
    },

    toggleRepliesExpanded() {
      if (this.caseFilesExpanded) {
        this.caseFilesExpanded = false;
      }
      
      this.repliesExpanded = !this.repliesExpanded;
    },

    createCase() {
      const url = `/cases?reviewId=${this.review.id}#case-create`;
      window.location.replace(url);
    },
    async saveNote() {
      if (this.noteText.length > 5000) {
        swal('Warning!', 'The note must be 5000 characters or less.', 'warning');
        return;
      }

      try {
        await axios.post(`/api/reviews/${this.currentTeam.id}/${this.review.id}/setNote`, {
          note: this.noteText,
        });

        this.review.note = this.noteText;
        this.closeNoteArea();
        swal('Success!', 'The note has been saved successfully.', 'success');
      } catch (e) {
        const errorMessage = e?.response?.data?.error?.note?.join('\n') ?? ""
        swal('Whoops!', errorMessage, 'error');
      }
    },

    toggleNoteArea() {
      this.isNoteActive = !this.isNoteActive;
    },

    closeNoteArea() {
      this.isNoteActive = false;
    },

    handleClick() {
      this.selected = !this.selected;
      this.$eventHub.$emit('review-selected', this.review.id, this.selected);
    },

    checkLanguagePreference() {
      if (this.preference && this.preference.settings && this.preference.settings.preferred_language) {
        this.viewTranslation = this.review.language !== this.preference.settings.preferred_language;
        this.viewManagerTranslation = this.comments.some((c) => c.language !== this.preference.settings.preferred_language);
      }
    },

    formatManagerComment(comment) {
      if (comment.translation && comment.translation.length > 1 && this.viewManagerTranslation) {
        return comment.translation;
      }

      return comment.comment;
    },

    checkAutoReviewsExpandPreference() {
      if (
          this?.preference?.settings?.auto_expand_reviews &&
          this.review?.comments?.length > 0 &&
          this.review.comments.some(comment => comment.kind === 'manager')
      ) {
          this.repliesExpanded = true;
      }

      if (
          this?.preference?.settings?.auto_expand_reviews &&
          this.review?.note?.length > 0
      ) {
			    this.isNoteActive = true;
      }
    },
    
    closeResponseArea() {
      this.activeHint = null;
      this.isResponseSuggestion = false;
      this.isRespondAreaActive = false;
    },

    expandSection() {
      this.activeHint = {
        hint_text: this.suggestionComment,
        rating: 'none',
      };
    },

    shareReview() {
      this.showShareReviewModal = true;
    },

    async translateReview(lang = null) {
      this.translating = true;
      const queryParams = lang ? `?target=${lang}` : '';
      try {
        const response = await axios.get(
          `/api/reviews/translate/${this.review.team_id}/${this.review.id}${queryParams}`
        );
        this.comments = response.data.comments;
        this.review.title_translation = response.data.title_translation;
        this.viewTranslation = true;
      } catch (error) {
        console.error(error);
      } finally {
        this.translating = false;
      }
    },

    deleteReview() {
      const that = this;
  
      swal({
          title: 'Are you sure you want to remove this review?',
          text: 'The action will apply immediately!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Remove!',
      }, (isConfirm) => {
          if (isConfirm) {
              axios
                  .delete(`/api/reviews/${this.review.team_id}/${this.review.id}/`)
                  .then((response) => {
                      if (response.data === 'success') {
                          swal('Done!', 'The review has been successfully deleted', 'success');
                          that.deleted = true;
                      } else {
                          swal('Whoops!', 'Something went wrong.', 'error');
                      }
                  })
                  .catch((error) => {
                      const errorMessage = error.response && error.response.data
                          ? error.response.data.message || 'An unexpected error occurred.'
                          : 'An unexpected error occurred.';
                      swal('Whoops!', errorMessage, 'error');
                  });
          }
      });
    },  
    getTermText(id) {
      let termText = '';
      for (let comment of this.review.comments) {
        for (let term of comment.terms) {
          if (term.id == id) {
            return term.term + ' ' + term.target;
          }
        }
      }
      return termText;
    },

    showSentimentPopup(e) {
      const target = e.target;
      this.selectedTerm.id = $(target).data('term-id');
      if (!this.selectedTerm.id) {
        this.selectedTerm.id = null;
        this.selectedTerm.title = null;
        // If switching from other term hide all.
        $('.response-popover').addClass('hide');
        return;
      }

      this.selectedTerm.title = this.getTermText(this.selectedTerm.id);
      this.$refs.response_popover[0].classList.remove('hide');
    },

    closeSentimentPopup(e) {
      this.$refs.response_popover[0].classList.add('hide');
      this.$refs['option_positive'][0].classList.remove('highlight');
      this.$refs['option_negative'][0].classList.remove('highlight');
      this.$refs['option_neutral'][0].classList.remove('highlight');
    },

    updateTermSentiment(e, term, sentiment) {
      const target = e.target;

      let match = {
        positive: 0.6,
        neutral: 0,
        negative: -0.6,
      };

      for (let option in match) {
        this.$refs['option_' + option][0].classList.remove('highlight');
      }

      this.$refs['option_' + sentiment][0].classList.add('highlight');

      this.storingSentiment = true;
      const notify = this.$notify;
      setTimeout(() => {
        axios
          .post('/api/terms/' + Spark.state.currentTeam.id + '/sentiment', {
            newSentiment: sentiment,
            termId: this.selectedTerm.id,
          })
          .then((response) => {
            this.closeSentimentPopup(null);

            this.$parent.updateTermSentiment(this.reviewIndex, this.selectedTerm.id, match[sentiment]);
            this.storingSentiment = false;

            notify({
              group: 'reviews',
              title: 'Success!',
              text: 'The term sentiment was updated successfully.',
              position: 'bottom right',
              duration: 2000,
            });
          })
          .catch((response) => {
            this.storingSentiment = false;
          });
      }, 500);
    },

    publishReview() {
      axios
        .post('/api/reviews/' + Spark.state.currentTeam.id + '/' + this.review.id + '/publish', {
          published: this.review.published,
        })
        .then((response) => {
          this.review.published = response.data.published;

          if (this.review.published == 1) {
            this.$notify({
              group: 'reviews',
              title: 'Success!',
              text: 'The review has been published successfully.',
              position: 'bottom right',
              duration: 1000,
            });
          }
        });
    },

    invalidateEntity(entity, index) {
      swal(
        {
          title: 'Is this not correct?',
          text: "By deleting this, it won't be included in future reports!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
        },
        async () => {
          this.invalidating = true;
          axios
            .delete('/api/reviews/' + Spark.state.currentTeam.id + '/' + this.review.id + '/entities/' + entity.id)
            .then((response) => {
              this.entities[index] = response.data;
              this.invalidating = false;
            });
        },
      );
    },

    setLoadingHint(bool) {
      this.loadingHint = bool;
    },

    applyHint(hint) {
      // Suggestion has been loaded and loading css classes should be
      // removed.
      this.loadingHint = false;
      this.activeHint = hint;
      this.respond_message = hint.hint_text;
    },

    respondThroughRedirect(review) {
      this.active_popover = true;

      analytics.track('Respond To Review', {
        type: 'redirect',
        source: this.review.source,
      });
      window.open(this.respond_url, '_blank');
    },

    markReviewAsResponded(review) {
      axios
        .post('/api/reviews/' + Spark.state.currentTeam.id + '/' + review.id + '/markResponded')
        .then((response) => {
          this.active_popover = false;
          this.responded_manually = true;
        })
        .catch((error) => {
          swal('Oops!', 'Something went wrong with your response. Our team has been notified', 'danger');
        });
    },

    closePopover() {
      this.active_popover = false;
    },

    toggleTranslation(event) {
      event.preventDefault();
      this.viewTranslation = !this.viewTranslation;
    },

    toggleManagerTranslation(event) {
      event.preventDefault();
      this.viewManagerTranslation = !this.viewManagerTranslation;
    },

    suggestResponse(review_id) {
      axios
        .get('/api/reviews/' + review_id + '/suggest-response')
        .then((response) => {
          this.response_suggestion = response.data;
        })
        .catch((error) => {
          swal('Oops!', 'Something went wrong with your response. Our team has been notified', 'danger');
        });
    },

    openRespond(source) {
      this.isFormVisible = true;
    },

    cancelRespond(source) {
      this.respond_message = '';
      this.isFormVisible = false;
    },

    setResponseMessage(message) {
      this.respond_message = message;
    },

    respond() {
      this.isResponseLoading = true;

      if (this.respond_message == '') {
        return;
      }

      analytics.track('Respond To Review', {
        type: 'integration',
        source: this.review.source,
      });

      var data = {
        response_text: this.respond_message,
      };

      axios
        .post('/api/reviews/' + this.review.id + '/' + this.review.team_id + '/respond/', data)
        .then((response) => {
          if (response.data && response.data.comment) {
            this.comments.push(response.data.comment);
          }

          this.isResponseLoading = false;
          
          var instance = this;

          swal({
            title: 'Success!',
            text: 'Your reply has been submitted successfully.',
            type: 'success',
            confirmButtonText: "OK",
          }, function () {
              this.isRespondAreaActive = false;
              this.respond_message = ''; 
              instance.$parent.updatePage(instance.params);
          });
        })
        .catch((error) => {
          this.isResponseLoading = false;
            swal({
              title: 'Oops!',
              text: 'Something went wrong with your response.\n Our team has been notified',
              type: 'warning',
              buttons: false,
              allowOutsideClick: true,
              allowEscapeKey: true,
            });
        });
    },

    ucFirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    highlightTerms(comment, language, showSentiment) {
      let txt =
        comment.translation != null && comment.translation.length > 1 && this.viewTranslation
          ? comment.translation
          : comment.comment;

      let should_highlight = comment.terms.length > 0;

      if (comment.translation != null && comment.translation.length > 1) {
        should_highlight = this.viewTranslation;
      }

      let comment_str = '';
      if (should_highlight || showSentiment) {
        let terms = [];

        if (showSentiment) {
          terms = comment.terms;
        } else {
          terms = this.filterTermsByParams(comment.terms, this.$parent.params, this.$parent.additionalParams);
        }

        comment_str = this.buildHighlightedCommentFromTerms(terms, txt);
      } else {
        comment_str = txt;
      }

      return comment_str;
    },

    isPunctOrSpace(char) {
      var re = new RegExp('^[^a-zA-Z0-9-]');

      // Returns true for space
      if (!char) {
        return true;
      }

      return re.test(char);
    },

    filterTermsByParams(terms, params, additionalParams) {
      // If no filters are active then highlighting is inactive.
      if (
        !params['sentimentCategory'] &&
        !params['keyword'] &&
        !params['terms'] &&
        !params['positiveNegativeOrBoth'] &&
        !params['insightRolling'] &&
        !params['insightAdhoc']
      ) {
        return [];
      }

      if (params['sentimentCategory']) {
        terms = terms.filter(function (element) {
          return element.category == params['sentimentCategory'];
        });
      }

      if (params['positiveNegativeOrBoth']) {
        if (params['positiveNegativeOrBoth'] == 'positive') {
          terms = terms.filter(function (element) {
            return element.sentiment_score > 0;
          });
        } else if (params['positiveNegativeOrBoth'] == 'negative') {
          terms = terms.filter(function (element) {
            return element.sentiment_score < 0;
          });
        }
      }

      if (params['keyword']) {
        terms = terms.filter(function (element) {
          return element.target == params['keyword'];
        });
      }

      if (params['subcategory']) {
        terms = terms.filter(function (element) {
          return element.subcategory == params['subcategory'];
        });
      }

      if (params['terms'].length > 0) {
        let tr = params['terms'].split(':');

        terms = terms.filter(function (element) {
          return element.target == tr[1] && element.term == tr[0];
        });
      }

      if (params['insightRolling'] || params['insightAdhoc']) {
        let keyword = additionalParams['insightKeyword'];

        terms = terms.filter(function (element) {
          return element.target == keyword;
        });
      }

      return terms;
    },

    // Builds a highlighted comment from terms
    buildHighlightedCommentFromTerms(terms, text) {
      let highlightedText = '';

      // Replace new lines with spaces
      text = text.replace(new RegExp('\\n', 'gm'), ' ');

      // If any double+ spaces occur then they are replaced by single spaces
      text = text.replace(/  +/g, ' ');

      if (terms) {
        var positions = [];
        var filled_positions = [];

        for (let term of terms) {
          // Skip neutral terms
          if (term.sentiment_score == 0) {
            continue;
          }

          let sentiment_type = 'neutral';

          if (term.sentiment_score < 0) {
            sentiment_type = 'negative';
          } else if (term.sentiment_score > 0) {
            sentiment_type = 'positive';
          }

          let term_position = {
            type: 'term',
            start: term.term_start,
            end: term.term_end,
            sentiment_type: sentiment_type,
            expected_word: term.term,
            term_id: term.id,
          };

          let keyword_position = {
            type: 'keyword',
            start: term.keyword_start,
            end: term.keyword_end,
            expected_word: term.target,
            term_id: term.id,
          };

          let keyword_str = term.keyword_start + ':' + term.keyword_end;
          let term_str = term.term_start + ':' + term.term_end;

          if (!filled_positions.includes(keyword_str)) {
            filled_positions.push(keyword_str);
            positions.push(keyword_position);
          }

          if (!filled_positions.includes(term_str)) {
            filled_positions.push(term_str);
            positions.push(term_position);
          }
        }
      }

      let current = 0;

      // Sort positions
      positions.sort(function compare(a, b) {
        if (a.start < b.start) return -1;
        if (a.start > b.start) return 1;
        return 0;
      });

      for (let position of positions) {
        let position_current = current;
        let position_start = position.start;
        let position_end = position.end;
        let expected_word = position.expected_word;
        let highlightedWord = text.substring(position_start, position_end);
        let steps = -2;
        if (highlightedWord.toLowerCase() != expected_word.toLowerCase()) {
          for (i = 0; i < 50; i++) {
            let start = position_start + (steps + i);
            let end = position_end + (steps + i);
            if (text.substring(start, end).toLowerCase() == expected_word.toLowerCase()) {
              position_start = start;
              position_end = end;
              highlightedWord = text.substring(position_start, position_end);
              break;
            }
          }
        }
        if (highlightedWord.toLowerCase().substring(0, 4) != expected_word.toLowerCase().substring(0, 4)) {
          continue;
        }

        highlightedText += text.substring(current, position_start);
        let className = position.type == 'term' ? 'term-mark' : 'keyword-mark';

        // Add term sentiment
        if (position.type == 'term') {
          className += ' ' + position.sentiment_type;
        }

        let randomString = Math.random().toString(36).substr(7);

        if (position.type === 'term') {
          highlightedText +=
            '<a data-term-id="' +
            position.term_id +
            '" tabindex="0" role="button" id="' +
            randomString +
            '" class="' +
            className +
            '" data-toggle="popover">' +
            highlightedWord +
            '</a>';
        } else {
          highlightedText += '<span class="' + className + '">' + highlightedWord + '</span>';
        }
        current = position_end;
      }

      // Add the remaining text to the string
      highlightedText += text.substring(current, text.length);

      return highlightedText;
    },

    toggleLanguageDropdown() {
      this.isLanguageDropdownOpen = !this.isLanguageDropdownOpen;
    },
  },
});

Vue.component('guestflip-reviews', {
	props: ['user', 'teams', 'sourcesOutOf'],

  data() {
    return {
		betaFeatures: [],
		response: {},
		sorting_fields: {
			published_date: 'Date',
			rating: 'Stars',
			sentiment_score: 'Sentiment',
			importance: 'Importance',
		},
		params: this.getOriginalReviewFilters(),
		additionalParams: {
			insightKeyword: '',
		},
		ratingFilter: -1,
    ratingPreference: 'standard',
		activeChannel: '',
		dateInputText: '',
		keyword: '',
		terms: '',
		responseFilter: '',
		showExportDialog: false,
		// By default sorting by date is active
		activeSort: { published_date: 'desc' },
		isLoading: false,
		reviewsStats: {},
		showAllSentiment: false,
		recommendationChannels: new Set(['holiday_check']),
	};
  },

  computed: {
    originalParamsActive() {
      let active = true;
      let orginal = this.getOriginalReviewFilters();

      for (var param_name in this.params) {
        if (param_name != 'fromDate' && param_name != 'toDate' && this.params[param_name] != orginal[param_name]) {
          active = false;
          break;
        }
      }

      return active;
    },
    hasReviewResponseApproval() {
      return this.betaFeatures.some((feature) => feature.feature === 'response_approval');
    },
  },

  async mounted() {
    Vue.nextTick(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });

    this.$on('change-page', (index) => {
      this.changePage(index);
    });
    const betaFeatures = await this.fetchBetaFeatures();
    this.betaFeatures = betaFeatures;
    var url = new URL(window.location.href);
    
    const fromDate = url.searchParams.get('from') 
      ? moment(url.searchParams.get('from')) 
      : (this.params.fromDate ? moment(this.params.fromDate) : moment().subtract(365, 'days'));
      
    const toDate = url.searchParams.get('to') 
      ? moment(url.searchParams.get('to')) 
      : (this.params.toDate ? moment(this.params.toDate) : moment());

    this.params['fromDate'] = fromDate.format('YYYY-MM-DD');
    this.params['toDate'] = toDate.format('YYYY-MM-DD');

    this.$eventHub.$on('applyFilters', (data) => {
      this.applyFilters(data);
    });

    this.$eventHub.$on('activateTab', (id) => {
      if (id == 'reviews' && !this.response) {
        this.updatePage(this.params);
      }
    });

    this.reviewsStats = await ReviewsService.stats(Spark.state.currentTeam.id);
		await ReviewsService.markAsSeen(Spark.state.currentTeam.id);
    this.ratingPreference = Spark.teamPreferences;
	},
	methods: {
		getRatingType(source) {
			return this.sourcesOutOf[source] || 5;
		},
    handleReviewsUpdated() {
      this.changePage(this.params['page'] ? this.params['page'] : 1);
    },
    async fetchBetaFeatures() {
      try {
        const response = await axios.get(`/api/teams/${Spark.state.currentTeam.id}/beta-features`);
        const betaFeatures = response.data;
        return betaFeatures;
      } catch (error) {
        console.error('Error fetching beta features:', error);
        throw error;
      }
    },
    updateTermSentiment(index, termId, score) {
      let term = null;
      for (let comment of this.response.data[index].comments) {
        for (let aTerm of comment.terms) {
          if (aTerm.id == termId) {
            term = aTerm;
            break;
          }
        }
      }
      if (!term) {
        return;
      }

      term.sentiment_score = score;
    },
    cancelAllFilters(event) {
      event.preventDefault();
      this.params = this.getOriginalReviewFilters();
      this.updatePage(this.params);
    },

    updatePage(params) {
      this.isLoading = true;

      var params_string = Object.keys(params)
        .map(function (k) {
          return params[k] == '' ? '' : encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
        })
        .filter(Boolean)
        .join('&');

      analytics.track('Updated Reviews', {
        filters: params,
      });

      // Apply the same terms to all related queries
      this.$eventHub.$emit('updateReviewQueryParams', this.params);

      axios.get('/api/reviews/' + Spark.state.currentTeam.id + '/?' + params_string).then((response) => {
        this.response = response.data;
        this.isLoading = false;
      });
    },

    changePage(index) {
      this.params['page'] = index;
      this.updatePage(this.params);
    },

    updateSearch(e) {
      this.params['search'] = e.target.value;
      this.updatePage(this.params);
    },

    sortBy(filterName) {
      if (filterName in this.activeSort) {
        this.activeSort[filterName] = this.activeSort[filterName] === 'desc' ? 'asc' : 'desc';
      } else {
        // Reset filters on new filter
        this.activeSort = {};
        this.activeSort[filterName] = 'desc';
      }

      this.params['sortBy'] = JSON.stringify(this.activeSort);
      this.updatePage(this.params);
    },

    filterSource(source) {
      this.params['source'] = source;
      // If the user clicks on the same channel again, then we cancel the filter
      if (this.activeChannel == source) {
        delete this.params['source'];
        this.activeChannel = '';
      } else {
        this.activeChannel = source;
      }

      // start from page 1 again
      this.params['page'] = 1;

      this.updatePage(this.params);
    },

    updateRatingFilter(ratingId) {
      if (this.ratingFilter == ratingId) {
        // Clicking on the same filter cancels the filter
        this.ratingFilter = -1;
        delete this.params['rating'];
      } else {
        this.ratingFilter = ratingId;
        this.params['rating'] = this.ratingFilter;
      }

      this.updatePage(this.params);
    },

    removeRatingFilter() {
      // Make sure that a rating filter is actually active
      if (this.ratingFilter !== -1) {
        this.updateRatingFilter(this.ratingFilter);
      }
    },

    filterByDescriptiveTerms(keyword, terms, positiveNegativeOrBoth, sentimentCategory) {
      if (this.params['sentimentGroup'] !== '') {
        return;
      }

      if (keyword == '') {
        delete this.params.keyword;
        this.keyword = '';
      } else {
        this.params['keyword'] = keyword;
        this.keyword = keyword;
      }

      if (terms.length) {
        this.terms = terms;
        this.params['terms'] = terms;
      } else {
        delete this.params.terms;
        this.terms = '';
      }

      this.params['page'] = 1;
      this.params['positiveNegativeOrBoth'] = positiveNegativeOrBoth;
      this.params['sentimentCategory'] = sentimentCategory;
      this.updatePage(this.params);
    },

    updateDates(from, to, dateRangeString) {
      this.params['fromDate'] = from;
      this.params['toDate'] = to;
      this.params['dateRangeString'] = dateRangeString;
      this.params['page'] = 1;

      this.updatePage(this.params);
    },

    directionArrow(direction) {
      if (direction == 'asc') {
        return '&uarr;';
      } else if (direction == 'desc') {
        return '&darr;';
      }
    },

    applyFilters(newParams) {
      if ('channel' in newParams) {
        this.activeChannel = newParams.channel;
        this.params['source'] = newParams.channel;
      }

      // Updates all parameters that have changed
      for (let paramName in newParams) {
        if (paramName in this.params) {
          this.params[paramName] = newParams[paramName];
        }

        if (paramName in this.additionalParams) {
          this.additionalParams[paramName] = newParams[paramName];
        }
      }

      if (
        this.params.sentimentGroup == '' &&
        this.params.sentimentCategory == '' &&
        this.params.keyword == '' &&
        this.params.subcategory == '' &&
        this.params.terms == ''
      ) {
        this.params.positiveNegativeOrBoth = '';
      }

      // Start from page 1
      this.params['page'] = 1;
      if ('perPage' in newParams) {
        this.params['perPage'] = newParams['perPage'];
      } else {
        this.params['perPage'] = 6;
      }

      this.updatePage(this.params);
    },

    toggleExportDialog() {
      this.showExportDialog = !this.showExportDialog;
    },
  },
});

Vue.component('active-filters', {
  props: ['filters'],
  data() {
    return {
      tagFilters: [
        'sentimentCategory',
        'terms',
        'keyword',
        'subcategory',
        'sentimentGroup',
        'countryCode',
        'ratingsCategory',
        'suggestionComment',
      ],
    };
  },

  computed: {
    activeFilters() {
      let instance = this;

      // Hehe
      let filteredFilters = Object.keys(this.filters).reduce(function (active, index) {
        if (instance.filters[index] != '' && instance.filters[index] != '-' && instance.tagFilters.includes(index)) {
          active[index] = {
            value: instance.filters[index],
            label: instance.makeLabel(instance.filters[index], index),
          };
        }

        return active;
      }, {});

      return filteredFilters;
    },
  },
  methods: {
    // Creates a nice readable label from a value and the type of value
    makeLabel(value, type) {
      if (type == 'terms') {
        let parts = value.split(':');
        value = this.ucFirst(parts[0]) + ' ' + parts[1];
      } else if (type == 'keyword') {
        value = this.ucFirst(value);
      } else if (type == 'sentimentCategory') {
        value = 'Category: ' + value;
      } else if (type == 'subcategory') {
        value = 'Topic: ' + this.labelizeGeneral(value);
      } else if (type == 'sentimentGroup') {
        value = 'Group: ' + this.labelizeGeneral(value);
      } else if (type == 'countryCode') {
        value = 'Country: ' + GeoMappingsService.alpha2(value);
      } else if (type == 'ratingsCategory') {
        value = 'Rating Category: ' + this.labelizeGeneral(value);
      } else if (type == 'suggestionComment') {
        value = 'Suggestion Comment: ' + this.labelizeGeneral(value);
      }

      return value;
    },

    removeFilter(filterName) {
      // Reset value for filter
      let data = {};
      data[filterName] = '';
      this.$eventHub.$emit('applyFilters', data);
    },
  },
});

Vue.component('positive-negative-filter', {
  props: ['filter'],
  template: `
        <div class="positive-negative-filter">
            <a v-for="option in options" href="#" @click="addFilter($event, option)" :class="optionClasses(option)">
                <strong class="light-text">{{ labelize(option) }}</strong>
            </a>
        </div>
    `,
  data() {
    return {
      options: ['both', 'positive', 'negative'],
    };
  },
  methods: {
    labelize(option) {
      let label = option;

      if (option == 'both') {
        label = 'all';
      }

      return label.toUpperCase();
    },
    addFilter(event, option) {
      event.preventDefault();
      this.$eventHub.$emit('applyFilters', {
        positiveNegativeOrBoth: option,
      });
    },
    optionClasses(option) {
      let optionClass = 'sentiment-' + option + '-filter';

      if (this.filter == option || (option == 'both' && this.filter == '')) {
        optionClass += ' active';
      }

      return optionClass;
    },
  },
});
